import { SelectOptionType } from '@octano/global-ui';

export interface AcademicOffer {
  id: number;
  periodId: number;
  periodName: string;
}

export type AcademicOfferResponse = AcademicOffer[];
export interface FirstInstallmentRule {
  id: number;
  code: string;
  name: string | null;
  data: {
    date?: string;
    month?: string;
    day?: string;
    validity?: number;
  };
}

export enum AdmissionScope {
  OS = 'OS',
  OL = 'OL',
}

export interface Subprocess {
  admissionId: number;
  subprocessId: number;
  studyPlanName: string;
  scheduleName: string;
  campusName: string;
  startDate: string | null;
  duration: string | null;
  admissionScopes: AdmissionScope[];
}
export interface ProcessList {
  id: number;
  name: string;
  isMultiTuition: boolean;
  firstInstallmentRule?: FirstInstallmentRule | null;
  subprocess?: Subprocess[];
}

export type ProcessListResponse = ProcessList[];

export interface ProcessListTable extends Omit<ProcessList, 'subprocess'> {}

export interface OfferListTable extends Subprocess {}

export interface FirstInstallmentRuleFormValues {
  firstInstallmentRule: SelectOptionType | null;
  selectDay: string | null;
  selectMonth: SelectOptionType | null;
  selectDate: string | null;
  validityRange: string | null;
  selectYear: SelectOptionType | null;
}

export interface ProcessListFormValues extends FirstInstallmentRuleFormValues {
  hasMultiTuition: SelectOptionType | null;
}

export interface OfferListFormValues {
  startDate: string | null;
  duration: string | null;
  enrollmentType: SelectOptionType | null;
}

export interface Process {
  id: number;
  name: string;
  isMultiTuition: boolean;
  firstInstallmentRule?: FirstInstallmentRule | null;
}
export interface Offer {
  admissionId: number;
  admissionScopes: AdmissionScope[];
  campusName: string;
  duration: string | null;
  scheduleName: string;
  startDate: string | null;
  studyPlanName: string;
  subprocessId: number;
}

export enum FirstInstallmentRuleKeys {
  SPECIFIC_DATE = 'specificDate',
  SPECIFIC_MONTH_DAY = 'specificMonthDay',
  NEXT_MONTH = 'nextMonth',
  NEXT_MONTH_DAY = 'nextMonthDay',
}

export interface ProcessUpdateBody {
  hasMultiTuition: boolean;
  firstInstallmentRuleValue: {
    key: string;
    value: {
      date?: string;
      month?: string;
      day?: number;
      validity?: number;
    };
    firstInstallmentRuleId?: number;
  };
}

export interface AdmissionUpdateBody {
  startDate: string | null;
  duration: string | null;
  admissionScopes: AdmissionScope[] | null;
}
